import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginModal = ({ onLogin, toggleSignUpModal, toggleAdminLogin }) => {
  const [activeTab, setActiveTab] = useState('individual');
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    onLogin(); // Call the callback to close the modal
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="relative w-full items-center flex justify-center flex-col p-8 py-12 bg-[#F6F2EF] shadow-md rounded-3xl border border-gray-200">
        <h1 className="text-2xl font-bold text-center text-[#362269] p-1 rounded-lg mb-6 w-fit">ARE YOU IN?</h1>

        <button className="absolute right-3 top-4 text-black" onClick={onLogin}>
          &#10006;
        </button>

        <div className="flex justify-center mb-4 w-full">
          <button
            onClick={() => setActiveTab('individual')}
            className={`flex-1 text-center py-2 border-b-4 ${activeTab === 'individual' ? 'text-[#362269] border-[#C6AFFF]' : 'text-gray-500 border-transparent'}`}
          >
            Volunteer 
          </button>

          <button
            onClick={() => setActiveTab('organisation')}
            className={`flex-1 text-center py-2 border-b-4 ${activeTab === 'organisation' ? 'text-[#362269] border-[#C6AFFF]' : 'text-gray-500 border-transparent'}`}
          >
            Organization
          </button>
        </div>

        <form className="w-full" onSubmit={handleFormSubmit}>
          {activeTab === 'individual' ? (
            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="Name *"
                  className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                />
              </div>

              <div>
                <input
                  type="password"
                  placeholder="Password *"
                  className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                />
              </div>

              <div className="flex flex-col justify-center items-center text-center">
                <button
                  type="submit"
                  className="common_btn mb-4"
                  style={{ backgroundColor: "#C6AFFF" }}
                  onClick={() => navigate("/volunteer")}
                >
                  Log in
                </button>

                <div className="flex justify-between w-full">
                  <span className="flex">
                    Don’t have an account?&nbsp;
                    <button
                      type="button"
                      className="text-sm text-[#C6AFFF] hover:underline"
                      onClick={toggleSignUpModal}
                    >
                      Create Account
                    </button>
                  </span>

                  <button
                    type="button"
                    className="text-sm text-[#C6AFFF] hover:underline"
                    onClick={() => {
                      onLogin(); // Close the current modal
                      toggleAdminLogin(); // Open the admin login modal
                    }}
                  >
                    Login as Admin
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="Organization Name *"
                  className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                />
              </div>

              <div>
                <input
                  type="password"
                  placeholder="Password *"
                  className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                />
              </div>

              <div className="flex flex-col justify-center items-center text-center">
                <button
                  type="submit"
                  className="common_btn mb-4 bg-[#C6AFFF]"
                  style={{ backgroundColor: "#C6AFFF" }}
                  onClick={() => navigate("/organization")}
                >
                  Log in
                </button>

                <div className="flex justify-between w-full">
                  <span className="flex">
                    Don’t have an account?&nbsp;
                    <button
                      type="button"
                      className="text-sm text-[#C6AFFF] hover:underline"
                      onClick={toggleSignUpModal}
                    >
                      Create Account
                    </button>
                  </span>

                  <button
                    type="button"
                    className="text-sm text-[#C6AFFF] hover:underline"
                    onClick={() => {
                      onLogin(); // Close the current modal
                      toggleAdminLogin(); // Open the admin login modal
                    }}
                  >
                    Login as Admin
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
